
import { socketTableRows } from '@/utils/vehicleSocketTable'

export default {
  name: 'VehicleSocketTable',
  props: {
    blocks: {
      type: Array,
      required: true,
    },
  },
  computed: {
    rows() {
      return socketTableRows(this.blocks)
    },
    fields() {
      return [
        {
          key: 'light',
          label: this.$t('components.vehicleSocketTable.light'),
        },
        {
          key: 'sockets',
          label: this.$t('components.vehicleSocketTable.socket'),
        },
      ]
    },
  },
  methods: {
    anchorOf(type) {
      return `feux-${this.$slugify(type.name).toLowerCase() || type.id}`
    },
    select(item, version) {
      this.$emit('select', {
        typeId: item.type.id,
        detailId: item.versions.length > 1 ? version.id : null,
      })
    },
  },
}
